module.exports = __webpack_public_path__ + "static/media/drugstore.9303453f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/drugstore.jpg
// module id = 1525
// module chunks = 0